<template>
  <v-dialog v-model="incorporateHelp" persistent scrollable max-width="70%">
    <v-card class="pb-5">
      <v-card-title>
        <span class="headline" v-t="{path: 'ITEM'+this.incorporateKey+'.SHORTTITLE', locale: version}"></span>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" flat @click.native="close">
          <span v-html="$t('questionnaire.itemHelpDialog.CLOSE_BUTTON')"></span>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text v-show="incorporateSection == 'text'" v-html="$t('ITEM'+this.incorporateKey+'.HELP_INCORPORATE', version)">
      </v-card-text>

      <v-card-text v-show="incorporateSection == 'help'" v-html="$t('ITEM'+this.incorporateKey+'.HELP_ITEMS.TEXT', version)">
      </v-card-text>

      <v-bottom-nav
        absolute
        shift
        :value="true"
        :active.sync="incorporateSection"
        color="primary"
      >
        <v-btn dark value="text">
          <span v-t="{path: 'ICONS.TEXT', locale: version}"></span>
          <v-icon>description</v-icon>
        </v-btn>

        <v-btn dark value="help">
          <span v-t="{path: 'ICONS.HELP', locale: version}"></span>
          <v-icon>help_outline</v-icon>
        </v-btn>
      </v-bottom-nav>
      <v-divider></v-divider>
      <v-card-actions>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 40px); /* Adjust as needed */
  }
</style>

<script>
  export default {
    name: 'evaloeResults',
    props: ['version', 'incorporateHelp', 'incorporateKey', 'short'],
    data () {
      return {
        incorporateSection: 'text',
        video: null,
        audio: null,
        signed: null
      }
    },
    created: function () {},
    mounted: function () {},
    watch: {},
    computed: {},
    methods: {
      close: function () {
        this.video = document.getElementById('assistVideo' + this.incorporateKey)
        this.audio = document.getElementById('assistAudio' + this.incorporateKey)
        this.signed = document.getElementById('assistSigned' + this.incorporateKey)

        if (this.video !== null) this.video.pause()
        if (this.audio !== null) this.audio.pause()
        if (this.signed !== null) this.signed.pause()
        this.incorporateSection = 'text'
        this.$emit('close')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/questionnaires/EvaloeAssist.vue